export class BillActionModel {
    public billingIds: string[];
    public validate?: boolean;
}
